import { CoreContext } from "context/CoreContext";
import React, { useContext, useState } from "react";   
import { useHistory } from "react-router-dom";
import { DoLogout } from "services/authentication";

import {   
    HeaderMenu,
    HeaderMenuImage,
    HeaderMenuIcon,
    HeaderMenuContent,
    HeaderMenuContentSection,
    HeaderMenuUser,
    HeaderMenuUserImage,
    HeaderMenuOption,
    HeaderMenuOverlay
} from "./styled"; 

//Aqui é a parte que tem o avatar do usuario, troca de perfil, gerenciamento da conta, sair etc.
const HeaderMenuComponent = () => {
    const { currentProfile, profiles, setCurrentProfile } = useContext(CoreContext);
    const [showMenu, setShowMenu] = useState(false);
    const history = useHistory();

    const handleToggleMenu = () => {
        setShowMenu(!showMenu);
    };

    const handleLogout = async () => {
        await DoLogout();
        history.push('/login');
    };

    const handleProfileChange = (profile) => {
        setCurrentProfile(profile);
        setShowMenu(false);
    };

    return (
        <>
            <HeaderMenu onClick={handleToggleMenu}>
            <HeaderMenuImage image={ currentProfile?.avatar?.image ? currentProfile?.avatar?.image : '/images/users/face.png' } />
                {/*<span>{currentProfile?.name}</span>*/}
                <HeaderMenuIcon style={{ transform: showMenu ? 'rotate(180deg)' : 'none' }} />
            </HeaderMenu>

            {showMenu && (
                <>
                    <HeaderMenuOverlay isOpen={true} onClick={handleToggleMenu} />
                    <HeaderMenuContent>
                        <HeaderMenuContentSection>
                            {profiles && profiles.map((profile, key) => (
                                <HeaderMenuUser key={key} onClick={() => handleProfileChange(profile)}>
                                   {/*} <HeaderMenuUserImage image={profile.avatar || '/images/users/face.png'} />*/}
                                    {/*<span>{profile.name}</span>*/}
                                </HeaderMenuUser>
                            ))}
                            <HeaderMenuOption onClick={() => {
                                setShowMenu(false);
                                history.push('/dashboard/select-profile?manage=true');
                            }}>
                                Gerenciar perfil
                            </HeaderMenuOption>
                        </HeaderMenuContentSection>
                        <HeaderMenuContentSection white>
                            <HeaderMenuOption onClick={() => {
                                setShowMenu(false);
                                history.push('/dashboard/history');
                            }}>
                                📚 Minhas conversas
                            </HeaderMenuOption>
                            <HeaderMenuOption onClick={() => {
                                setShowMenu(false);
                                history.push('/dashboard/account');
                            }}>
                                Minha conta
                            </HeaderMenuOption>
                            <HeaderMenuOption onClick={() => {
                                setShowMenu(false);
                                history.push('/dashboard/help');
                            }}>
                                Ajuda
                            </HeaderMenuOption>
                            <HeaderMenuOption onClick={() => {
                                setShowMenu(false);
                                history.push('/dashboard/about');
                            }}>
                                Sobre
                            </HeaderMenuOption>
                            <HeaderMenuOption onClick={handleLogout}>
                                Sair
                            </HeaderMenuOption>
                        </HeaderMenuContentSection>
                    </HeaderMenuContent>
                </>
            )}
        </>
    );
};

export default HeaderMenuComponent;

